export default {
    AVAILABLE: "Available",
    LISTING: "Listing",
    UNDER_OFFER: "Under Offer",
    SALE_AGREED: "Sale Agreed",
    OFF_MARKET: "Off Market",
    SOLD: "Sold",
    RENTED: "Rented"
}
